import { getAuth, signOut } from "firebase/auth";
import { ref, set, serverTimestamp } from "firebase/database";
import { firebaseApp, firebaseDb } from "../firebase/app";

/**
 * Set user presence to offline in Firebase
 * Must be called BEFORE signOut to maintain valid auth
 */
export const setUserOffline = async (dealerUid: string | null, userUid: string | null) => {
  if (!dealerUid || !userUid) return;

  const presencePath = `dealers/${dealerUid}/info/users/${userUid}/presence`;
  const presenceRef = ref(firebaseDb, presencePath);

  try {
    await set(presenceRef, {
      online: false,
      lastSeen: serverTimestamp(),
    });
    console.log(`[Presence] User ${userUid} set to offline`);
  } catch (error: any) {
    // Silently ignore permission errors (can happen during edge cases)
    const errorMsg = String(error?.message || error || "").toLowerCase();
    if (!errorMsg.includes("permission")) {
      console.error("[Presence] Error setting offline:", error);
    }
  }
};

/**
 * Logout user - sets offline status first, then signs out
 */
export const logoutUser = async (dealerUid: string | null, userUid: string | null) => {
  // Set offline BEFORE signing out (while auth is still valid)
  await setUserOffline(dealerUid, userUid);

  // Now sign out
  const auth = getAuth(firebaseApp);
  await signOut(auth);
};
